module.exports = __webpack_public_path__ + "assets/img/官网首页_05.a958e7ca.jpg";